export enum FeatureTour {
  Onboarding = "onboarding",
  TalentPool = "talent_pool",
  JobManagement = "job_management",
}

export const POINTER_RADIUS = 16;
export const POINTER_PADDING = 5;
